import { Box, SxProps, Theme } from '@mui/material';
import React from 'react';
import { getStatusPalette, StatusSize } from '../status-badge/status-palette';

export type StatusIconSize = StatusSize;

export interface StatusIconProps {
  status: boolean;
  /** `small` for dense rows; `medium` for headers / standalone. */
  size?: StatusIconSize;
  className?: string;
  style?: React.CSSProperties;
  sx?: SxProps<Theme>;
}

/**
 * Standalone icon sizes — larger step than StatusBadge’s in-pill dots so small/medium read clearly.
 */
function getIconMetrics(size: StatusIconSize) {
  if (size === 'medium') {
    return { dot: 12, ring: 4 };
  }
  return { dot: 8, ring: 3 };
}

/**
 * Haloed online / offline status dot (the indicator from StatusBadge, without the pill label).
 */
export function StatusIcon({ status, size = 'small', sx, className, style }: StatusIconProps) {
  return (
    <Box
      component="span"
      className={className}
      style={style}
      sx={[
        (theme) => {
          const palette = getStatusPalette(status, theme.palette.mode);
          const metrics = getIconMetrics(size);
          return {
            display: 'inline-block',
            width: metrics.dot,
            height: metrics.dot,
            borderRadius: '50%',
            flexShrink: 0,
            backgroundColor: palette.dot,
            boxShadow: `0 0 0 ${metrics.ring}px ${palette.ring}`,
          };
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    />
  );
}
